<template>
  <v-navigation-drawer width="280" v-model="drawer" light floating app>
    <v-list class="pa-0">
      <v-list-item @click="toUrl">
        <v-list-item-content>
          <v-img :src="$imgUrl(appLogo)" />
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list-item @click="toUrl" class="py-0">
        <v-list-item-content class="py-0">
          <list-avatar
            :title="`<span class=font-weight-bold>${currOperator || langganan?.nama}</span>`"
            :tile="true"
            :size="64"
          >
            <img :src="$imgUrl(currLogoUrl)" alt="foto-profil" />
          </list-avatar>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider />
    <v-list nav dense class="px-0" tile>
      <v-list-item-group active-class="my-active-link">
        <template v-for="item in menus">
          <template v-if="item.children">
            <v-list-group
              :key="item.title"
              :prepend-icon="item.icon"
              active-class="my-active-link"
              :value="menuAktif === item.link"
              v-if="$allow(item.akses)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="(child, i) in item.children">
                <v-list-item :key="i" :to="child.to" v-if="$allow(child.akses)">
                  <v-list-item-icon v-if="child.icon">
                    <v-icon v-text="child.icon" />
                  </v-list-item-icon>
                  <v-list-item-content :class="{ 'pl-13': !child.icon }">
                    <v-list-item-title v-text="child.title" />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-item :key="item.title" :to="item.to" v-if="$allow(item.akses)">
              <v-list-item-icon>
                <v-icon v-text="item.icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import menus from '@/menus';
import { isObject } from '@utils/format';

export default {
  props: ['value'],
  data() {
    return {
      model: true,
      drawer: true,
    };
  },
  computed: {
    ...mapState('auth', {
      role: (state) => state.role,
      user: (state) => state.user,
    }),

    ...mapGetters({
      isUcm: 'auth/isUcm',
    }),

    ...mapState('preferensi', {
      loggedAs: (state) => state.loggedAs,
      id: (state) => state.id,
      included: (state) => state.included,
      jenis: (state) => state.operator,
      isTnk: (state) => state.is_tnk || false,
      langganan: (state) => state.preferensi?.langganan || {},
    }),

    menus() {
      const MENUS = this.role === 'admin' ? menus.admin : menus.user;
      const needSubscribe = !isObject(this.langganan) || (this.langganan && this.langganan.k_status_berkas !== 5);

      return needSubscribe
        ? [
            {
              icon: 'mdi-credit-card',
              title: 'Berlangganan',
              desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
              link: 'berlangganan',
              to: { name: 'berlangganan' },
            },
          ]
        : MENUS;
    },

    menuAktif() {
      const route = (this.$route.name || 'home').split('-');
      // remove last index
      if (route.length > 1) route.splice(-1, 1);
      return route.join('-');
    },

    currOperator() {
      const details = this.$getIncluded(this.jenis, this.id);
      return this.$getAttr(details, 'nama') || this.langganan?.nama || 'Pengguna';
    },

    currLogoUrl() {
      const details = this.$getIncluded(this.jenis, this.id);
      const logo = this.$getAttr(details, 'url_logo');
      if (logo) return logo;

      return 'https://cdn.siap.id/s3/smart%20village/ucm/asset%20img/sim/Elok-Desa%20default%20profil.png';
    },

    appLogo() {
      const logos = {
        wisata: 'https://cdn.siap.id/s3/smart%20village/ucm/asset%20img/sim/logo_elok_wisata.jpg',
        desa: 'https://cdn.siap.id/s3/smart%20village/ucm/asset%20img/sim/Elok-Desa%20logo.png',
        bangsal: 'https://cdn.siap.id/s3/smart%20village/ucm/asset%20img/sim/Elok%20logo.png',
      };
      return this.isUcm ? logos.desa : this.isTnk ? logos.wisata : logos.bangsal;
    },
  },
  methods: {
    toUrl() {
      this.$router.push({ name: 'home' }).catch(() => {
        // Abaikan kegagalan navigasi akibat redirect otomatis
      });
    },
  },
  watch: {
    value(val) {
      this.drawer = val;
    },
    drawer(val) {
      this.$emit('input', val);
    },
  },
};
</script>
<style scoped>
#inspire .my-active-link {
  color: #4eae51 !important;
  background-color: #e1f1e4 !important;
  border-right: 3px solid #4eae51;
}

#bangsal .my-active-link {
  color: #0059af !important;
  background-color: #deeeff !important;
  border-right: 3px solid #0059af;
}

#wisata .my-active-link {
  color: #6d0307 !important;
  background-color: #deeeff !important;
  border-right: 3px solid #6d0307;
}

.pl-13 {
  padding-left: 56px !important;
}
</style>
